import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Nav, NavController, NavParams, ModalController } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {objectAssign} from "@ionic/app-scripts";
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import {OrdersPage} from "../orders/orders";
import {PrintPage} from "../print/print";
import {ReklamationPage} from "../reklamation/reklamation";
import {Camera, CameraOptions} from "@ionic-native/camera";
import { File } from '@ionic-native/file';
import {WareneingangPage} from "../wareneingang/wareneingang";

/**
 * Generated class for the OrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pv',
  templateUrl: 'pv.html',
})
export class PvPage implements OnDestroy {
  @ViewChild(Nav) nav: Nav;


  pv = null;
  title = 'wird geladen...';

  nummer = null;

  anzahl = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, public http: HttpClient, private barcodeScanner: BarcodeScanner, public modalCtrl: ModalController, private camera: Camera, private file: File) {
    this.load(navParams.get('item'));
  }


  ionViewDidLoad() {
  }

  ngOnDestroy() {
    this.data.loadList();
  }

  scan() {
    this.barcodeScanner.scan({torchOn: true}).then((barcodeData) => {
      let scanned_pv = '0';
      if (barcodeData.format === 'QR_CODE') {
        const bstring = barcodeData.text.split('#');
        if (bstring[1] !== undefined) {
          scanned_pv = bstring[1];
        }
      }
      if (barcodeData.format === 'CODE_39') {
        scanned_pv = barcodeData.text;
      }
      this.load(scanned_pv);
    }, (err) => {

    });
  }

  load(number) {
    const body = {
      token: localStorage.getItem('token'),
      module: 'packages',
      submodule: 'load_md5',
      data: {id: number}
    };
    this.http.post(environment.api_url, body).subscribe(daten => {
        this.pv = daten['data'];
        this.loadImages();
        if (this.pv.art !== undefined) {
          this.title = this.pv.art + ' ' + this.pv.nummer + ' ' + this.pv.ort;
        } else {
          alert("Keine passende Packvorschrift gefunden.");
          if (this.data.role === 'Wareneingang') {
            this.navCtrl.setRoot(WareneingangPage);
          } else {
            this.navCtrl.setRoot(OrdersPage);
          }
        }
      }, error => {
      }
    );
  }

  loadImages() {
    for (const article in this.pv.artikel) {
      this.loadImage(article);
    }
  }

  loadImage(array_key) {
    const article = this.pv.artikel[array_key];

    let md5 = localStorage.getItem('md5_img_' + this.pv.artikel[array_key].id);

    this.file.checkFile(this.file.cacheDirectory, 'img_' + article.id).then(data => {
      if (md5 === this.pv.artikel[array_key].bild_md5) {
        this.file.readAsText(this.file.cacheDirectory, 'img_' + article.id).then( data => {
          this.pv.artikel[array_key].bild = data;
        });
      } else {
        this.loadAndSaveImage(article, array_key);
      }
    }).catch(data => {
      this.loadAndSaveImage(article, array_key);
    });
  }

  loadAndSaveImage(article, array_key) {
    const body = {
      token: localStorage.getItem('token'),
      module: 'articles',
      submodule: 'image',
      data: article
    };
    this.http.post(environment.api_url, body).subscribe(daten => {
        this.pv.artikel[array_key].bild = daten['data'];
        this.file.writeFile(this.file.cacheDirectory, 'img_' + article.id, daten['data'], {replace: true});
        localStorage.setItem('md5_img_' + this.pv.artikel[array_key].id, this.pv.artikel[array_key].bild_md5);
      }, error => {
      }
    );
  }

  auftrag() {
    let active = {
      id: 'new',
      pv_id: this.pv.id,
      anzahl: this.anzahl,
      erledigt: 0,
    };
    const body = {
      token: localStorage.getItem('token'),
      module: 'orders',
      submodule: 'save',
      data: active
    };
    if (this.anzahl > 0) {
      this.http.post(environment.api_url, body).subscribe(daten => {
        this.navCtrl.setRoot(OrdersPage);
        }, error => {
        }
      );
    }
  }

  drucken() {
    const order = {
      anzahl: 10,
      erledigt: 0,
      id: 'new',
      pv: this.pv.id
    };
    let profileModal = this.modalCtrl.create(PrintPage, { order: order });
    profileModal.present();
  }

  reklamation() {
    this.navCtrl.push(ReklamationPage, {pv: this.pv});
  }
  reklamation2() {
    // let profileModal = this.modalCtrl.create(ReklamationPage);
    // profileModal.present();
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      const image = 'data:image/jpeg;base64,' + imageData;
      const body = {
        token: localStorage.getItem('token'),
        module: 'orders',
        submodule: 'reklamation',
        image: imageData,
      };
      const sub = this.http.post(environment.api_url, body).subscribe(daten => {
          sub.unsubscribe();
        }, error => {
        }
      );
    }, (err) => {
      // Handle error
    });
  }

  popView() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pv/pv.ts